import { useEffect, useState } from 'react';

import { useSchedulerVersions } from '../../hooks/useSchedulerVersions';

export interface SchedulerVersionResolutionPromptProps {
  currentVersion: string;
  defaultSelectedVersion: string;
  onConfirm: (selectedVersion: string) => void;
}

export const useSchedulerVersionModal = (
  props: SchedulerVersionResolutionPromptProps | null
) => {
  const [selectedVersion, setSelectedVersion] = useState<string>('');
  const { availableVersions, isLoading, error } = useSchedulerVersions();

  useEffect(() => {
    if (props?.defaultSelectedVersion) {
      setSelectedVersion(props?.defaultSelectedVersion);
    }
  }, [props?.defaultSelectedVersion]);

  const handleVersionSelect = (version: string) => {
    setSelectedVersion(version);
  };

  const handleConfirm = () => {
    if (selectedVersion) {
      props?.onConfirm(selectedVersion);
    }
  };

  if (isLoading || error || !props) {
    return null;
  }

  return {
    isOpen: true,
    currentVersion: props?.currentVersion,
    availableVersions,
    selectedVersion,
    onVersionSelect: handleVersionSelect,
    onConfirm: handleConfirm,
    isConfirmDisabled: !selectedVersion,
  };
};
